export default "__VITE_ASSET__31q9I82y__"